/**
 * URL helper utilities for consistent URL generation
 */

/**
 * Get the best URL for a creator profile
 * Prefers username over wallet address for cleaner URLs
 */
export function getCreatorProfileUrl(
  walletAddress: string,
  username?: string | null
): string {
  return `/creator/${username || walletAddress}`;
}

/**
 * Get display name for a creator.
 * Every registered user has a username (mandatory on signup).
 */
export function getCreatorDisplayName(
  walletAddress: string,
  username?: string | null
): string {
  if (username) return username;
  // Should not happen for registered users
  console.warn('[getCreatorDisplayName] Username missing for wallet:', walletAddress.slice(0, 8));
  return 'Unknown';
}

/**
 * Check if a string looks like a Solana wallet address
 * Base58 encoded, typically 32-44 characters
 */
export function isWalletAddress(identifier: string): boolean {
  return /^[1-9A-HJ-NP-Za-km-z]{32,50}$/.test(identifier);
}
